const BRAND = process.env.REACT_APP_BRAND || 'default';

const configs = {
  default: require('./default'),
  jp: require('./jp')
};

module.exports = configs[BRAND];



// WEBPACK FOOTER //
// ./src/brand-configs/index.js